import { Box, Card, CardContent, CardHeader, List, ListItem, Typography } from "@mui/material";
import { Inventory2Outlined, SearchOff } from "@mui/icons-material";
import { useState } from "react";
import { CampaignFilters } from "./components/CampaignFilters";
import { Campaign, CampaignSorting } from "./models";
import { CardSearch } from "@arelia-components/ui-atoms/CardSearch";
import { useCampaignsList as useFilteredCampaigns } from "./hooks";
import { formatDate } from "@arelia-utils/helpers/dates";
import { useNavigate } from "react-router-dom";
import { PATHS } from "src/routes";
import SettingsProcessSteps from "../settings/SettingsProcessSteps";
import { EmptyMessage } from "@arelia-components/ui-atoms/EmptyMessage";

type Props = {
  campaigns: Campaign[];
}

export default function CampaignListPresenter({ campaigns }: Props) {
  const [sortCampaignsBy, setSortCampaignsBy] = useState(CampaignSorting.createdDateDesc);
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();

  const filteredCampaigns = useFilteredCampaigns(campaigns, sortCampaignsBy, searchValue);

  return (
    <>
      <Box sx={styles.topContainer}>
        <CampaignFilters
          sortCampaignsBy={sortCampaignsBy}
          setSortCampaignsBy={setSortCampaignsBy}
        />
        <SettingsProcessSteps clickEnabled={true} />
      </Box>

      <Box sx={styles.listBox}>
        <Card sx={styles.listCard}>
          <CardHeader
            title="Campaigns"
            sx={styles.listCardHeader}
            action={<CardSearch value={searchValue} onChange={setSearchValue} />}
          />
          <CardContent>
            {campaigns.length === 0 ? (
              <EmptyMessage icon={Inventory2Outlined} message="No Data To Display" />
            ) : filteredCampaigns.length === 0 ? (
              <EmptyMessage icon={SearchOff} message="No Data Match Search Request" />
            ) : (
              <List>
                {filteredCampaigns.map(campaign =>
                  <ListItem divider key={campaign.id} sx={styles.listItem} onClick={() => navigate(`${PATHS.CAMPAIGN_LIST}/${campaign.id}`)}>
                    <Typography variant="subtitle2" sx={styles.nameColumn}>
                      {campaign.name}
                    </Typography>
                    <Typography variant="subtitle2" sx={styles.fansColumn}>
                      {campaign.fans.length} fans
                    </Typography>
                    <Typography variant="subtitle2" sx={styles.dateColumn}>
                      {formatDate(campaign.createdAt, "MM/dd/yy hh:mm aa")}
                    </Typography>
                  </ListItem>
                )}
              </List>
            )}
          </CardContent>
        </Card>
      </Box>
    </>
  );
}

const styles = {
  listBox: {
    display: "flex",
    gap: "22px",
    alignItems: "flex-start"
  },
  listCard: {
    flex: 1
  },
  listCardHeader: {
    marginBottom: "16px"
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "start",
    padding: "10px",
    borderRadius: "6px",
    backgroundColor: "transparent",
    '&:hover': {
      backgroundColor: "rgba(6, 178, 218, 0.1)",
      cursor: "pointer"
    }
  },
  nameColumn: {
    flex: 4,
    minWidth: "150px"
  },
  fansColumn: {
    flex: 2,
    minWidth: "100px"
  },
  dateColumn: {
    minWidth: "200px",
    textAlign: "end"
  },
  topContainer: {
    display: "flex",
    justifyContent: "space-between"
  }
}